module.exports = __webpack_public_path__ + "static/media/brettk.22ee33b8.png";